// services/auth.ts
import { apiClient } from './api';
import { LoginRequest, RegisterRequest, AuthResponse, User } from '../types';

export const authService = {
  login: async (credentials: LoginRequest): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>('/Auth/login', credentials);
    return response.data;
  },

  sendVerificationCode: async (email: string): Promise<void> => {
    await apiClient.post('/Auth/send-code', JSON.stringify(email), {
      headers: { 'Content-Type': 'application/json' },
    });
  },

  verifyCode: async (email: string, code: string): Promise<void> => {
    await apiClient.post('/Auth/verify-code', { email, code });
  },
  register: async (userData: RegisterRequest): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>('/Auth/register', userData);
    return response.data;
  },

  logout: (): void => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  getToken: (): string | null => {
    return localStorage.getItem('token');
  },

  getCurrentUser: (): User | null => {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;
    
    try {
      return JSON.parse(userStr);
    } catch {
      return null;
    }
  },

  refreshToken: async (): Promise<AuthResponse> => {
    const response = await apiClient.post<AuthResponse>('/auth/refresh');
    return response.data;
  },
  resetPassword: async (email: string, code: string, newPassword: string): Promise<void> => {
  await apiClient.post('/Auth/reset-password', { email, code, newPassword });
},

sendResetCode: async (email: string): Promise<void> => {
  await apiClient.post('/Auth/send-reset-code', JSON.stringify(email), {
    headers: { 'Content-Type': 'application/json' },
  });
},

};